// extracted by mini-css-extract-plugin
export default {"container":"About_container__WazHV","about":"About_about__tFYRZ","images":"About_images__L0EFv"};